import { Expose, Transform, Type } from 'class-transformer';
import { ICanBeHistoricized } from '../../../shared/data-types/historic-types';
import { DateTimeHelper } from '../../../features/calendar/util/date-time-helper';

export class CostRateEntryModel implements ICanBeHistoricized {
  public id: number | null = null;
  @Expose({ name: 'starting_from' })
  @Transform(({ value }) => DateTimeHelper.format(value), { toPlainOnly: true })
  public startingFrom: Date | null = new Date();
  @Expose({ name: 'cost_rate_value' })
  @Type(() => Number)
  public rate: number | null = null;
  @Expose({ name: 'user_id' })
  public userId: number | null = null;
}
